"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSMMAPreOrderPaymentMethodsComponent = void 0;
const core_1 = require("@angular/core");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const profileBillingAddress_1 = require("../../../models/Profile/profileBillingAddress");
const orderStatus_service_1 = require("../../../services/orderStatus.service");
const constants = require("../../../util/constants");
const _ = require("underscore");
const loader_service_1 = require("../../../services/loader.service");
const generic_content_service_1 = require("../../../../mma/shared/services/generic.content.service");
class CSMMAPreOrderPaymentMethodsComponent {
    constructor(orderService, modalService, loaderService, genericContentService) {
        this.orderService = orderService;
        this.modalService = modalService;
        this.loaderService = loaderService;
        this.genericContentService = genericContentService;
        this.updatePaymentMethodStatusEmitter = new core_1.EventEmitter();
        this.refreshPreorderDetailsEmitter = new core_1.EventEmitter();
        this.isBTAEligible = false;
        this.showBTASection = false;
        this.isBTADropdownExpanded = false;
        this.isCardExpYearDropdownExpanded = false;
        this.isCardExpMonthDropdownExpanded = false;
        this.cardExpMonth = '';
        this.cardExpYear = '';
        this.showNewCardSection = false;
        this.creditCards = [];
        this.savedCCAddress = new profileBillingAddress_1.ProfileBillingAddress();
        this.selectedCCAddress = new profileBillingAddress_1.ProfileBillingAddress();
        this.isPayingThroughSavedCard = false;
        this.cardMonth = constants.cardMonth;
        this.disableSubmitButton = false;
        this.cardYear = new Array();
    }
    ngOnInit() {
        // Listen to the change event on payment method modal
        this.loadingSubscription = this.loaderService.changeEvent.subscribe(() => {
            this.getLoaderStatus();
        });
        this.getCardYear();
        this.getTokenServiceErrorJson();
    }
    ngOnChanges() {
        if (this.showPaymentMethods && this.preOrderData) {
            if (this.isLoggedInUser) {
                this.validateBillToAccount(true);
                this.getProfileBillingAddress();
                this.getProfileCreditCards(true);
            }
            else if (this.isVerifiedUser) {
                this.selectedPaymentMethod = 'newCard';
                this.updatePaymentMethod();
            }
            this.modalRef = this.modalService.open(this.modalPaymentMethods, { centered: true, backdrop: 'static' });
        }
    }
    getTokenServiceErrorJson() {
        this.orderService.getCSErrorMessage().subscribe((res) => {
            this.tokenErrorMessage = res;
        }, () => { });
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : (event.charCode >= 46 && event.charCode !== 47) && event.charCode <= 57;
    }
    getCardYear() {
        const d = new Date();
        let n = d.getFullYear();
        this.cardYear.push(n);
        for (let i = 0; i <= 9; i++) {
            n = n + 1;
            this.cardYear.push(n.toString());
        }
    }
    getCvvDetail() {
        this.genericContentService.getGenericContent('genericContentCVV').subscribe((data) => {
            this.cvvText = data.contentText;
            this.modalService.open(this.cvvDetails, { centered: true });
        }, (err) => {
            this.modalError = err;
        });
    }
    getProfileCreditCards(cachedResponse) {
        this.loaderService.showLoading();
        this.orderService.getProfileCreditCards(cachedResponse).subscribe((response) => {
            if (response && response.length > 0) {
                this.creditCards = response;
                this.selectedPaymentMethod = 'creditCard_0';
                this.transformSavedCCDetails();
            }
            else {
                this.selectedPaymentMethod = 'newCard';
                this.updatePaymentMethod();
            }
            this.loaderService.hideLoading();
        }, (error) => {
            this.loaderService.hideLoading();
        });
    }
    getProfileBillingAddress() {
        this.loaderService.showLoading();
        this.orderService.getProfileBillingAddress().subscribe((response) => {
            if (response) {
                this.billingAddress = response;
            }
            this.loaderService.hideLoading();
        }, (error) => {
            this.loaderService.hideLoading();
        });
    }
    validateBillToAccount(cachedResponse) {
        this.modalError = null;
        this.loaderService.showLoading();
        this.orderService.validateBillToAccount(cachedResponse, this.preOrderData).subscribe((res) => {
            this.isBTAEligible = res && res === 'true';
            this.loaderService.hideLoading();
        }, (error) => {
            this.isBTAEligible = false;
            this.loaderService.hideLoading();
        });
    }
    closeModal(isSuccessFlow) {
        this.resetPaymentSection();
        this.modalRef.close();
        if (isSuccessFlow) {
            this.refreshPreorderDetails();
        }
    }
    updatePaymentMethod() {
        if (this.selectedPaymentMethod === 'billToAccount') {
            this.showBTASection = true;
            this.btaMobileNumber = '';
            this.resetNewCardSection();
            this.resetSavedCardSection();
            this.getBillToAccountDetails(true);
        }
        else if (this.selectedPaymentMethod === 'newCard') {
            this.resetBTASection();
            this.resetSavedCardSection();
            this.showNewCardSection = true;
        }
    }
    resetBTASection() {
        this.btaMobileNumber = '';
        this.showBTASection = false;
        this.isBTADropdownExpanded = false;
    }
    resetNewCardSection() {
        this.showNewCardSection = false;
        this.isCardExpYearDropdownExpanded = false;
        this.isCardExpMonthDropdownExpanded = false;
        this.fname = '';
        this.ccnumber = '';
        this.cardExpMonth = '';
        this.cardExpYear = '';
        this.ccCVV = '';
    }
    resetSavedCardSection() {
        this.count = null;
        this.isPayingThroughSavedCard = false;
    }
    setBTADropdownStatus() {
        this.isBTADropdownExpanded = true;
    }
    setCCExpMonthDropdownStatus() {
        this.isCardExpMonthDropdownExpanded = true;
    }
    setCCExpYearDropdownStatus() {
        this.isCardExpYearDropdownExpanded = true;
    }
    getBillToAccountDetails(cachedResponse) {
        this.modalError = null;
        this.loaderService.showLoading();
        this.orderService.getBillToAccountDetails(cachedResponse).subscribe((res) => {
            this.mobileNumbers = res.mobileNumber;
            this.loaderService.hideLoading();
        }, (error) => {
            this.modalError = error;
            this.loaderService.hideLoading();
        });
    }
    transformSavedCCDetails() {
        const creditCardList = [];
        let ccCount = 1;
        if (this.creditCards && this.creditCards.length > 0) {
            this.creditCards.forEach(function (creditCard) {
                // This is for API, ideally this shud be removed from API
                if (creditCard.defaultCard === true) {
                    creditCard.ccCount = 0;
                }
                else {
                    creditCard.ccCount = ccCount++;
                }
                if (!creditCard.address) {
                    creditCard.address = {};
                }
                creditCard.address.address1 = creditCard.addressLine1;
                creditCard.address.address2 = creditCard.addressLine2;
                creditCard.address.postalCode = creditCard.zipcode;
                creditCard.address.city = creditCard.city;
                creditCard.address.state = creditCard.state;
                creditCard = _.omit(creditCard, [
                    'addressLine1',
                    'addressLine2',
                    'zipcode',
                    'city',
                    'state'
                ]);
                creditCardList.push(creditCard);
            });
        }
        this.creditCards = creditCardList;
        this.storeSavedCCDetails(this.creditCards[0], 0);
    }
    storeSavedCCDetails(card, count) {
        this.savedCCAddress.firstName = card.firstName;
        this.savedCCAddress.lastName = card.lastName;
        this.savedCCAddress.address1 = card.address.address1;
        this.savedCCAddress.address2 = card.address.address2;
        this.savedCCAddress.city = card.address.city;
        this.savedCCAddress.postalCode = card.address.zipcode;
        this.savedCCAddress.state = card.address.state;
        this.selectedSavedCC = card;
        this.isPayingThroughSavedCard = true;
        this.resetBTASection();
        this.resetNewCardSection();
        this.count = count;
    }
    resetPaymentSection() {
        this.updatePaymentMethodStatusEmitter.emit(false);
        this.resetBTASection();
        this.resetNewCardSection();
        this.resetSavedCardSection();
        this.selectedPaymentMethod = null;
        this.selectedAddressOption = null;
        this.selectedCCAddress = new profileBillingAddress_1.ProfileBillingAddress();
        this.isPayingThroughSavedCard = false;
    }
    submitUpdate(ccDetails) {
        if (this.selectedPaymentMethod === 'billToAccount') {
            this.UpdateBillToAccountPreorderTender();
        }
        else if (this.isPayingThroughSavedCard) {
            if (!this.selectedAddressOption || this.selectedAddressOption === 'billingAddr') {
                this.selectedCCAddress = this.savedCCAddress;
            }
            this.UpdateSavedCCPreorderTender();
        }
        else {
            this.newCCDetails = ccDetails;
            if (!this.selectedAddressOption || this.selectedAddressOption === 'billingAddr') {
                this.selectedCCAddress = this.billingAddress;
            }
            this.UpdateNewCCPreorderTender();
        }
    }
    UpdateBillToAccountPreorderTender() {
        this.modalError = null;
        this.loaderService.showLoading();
        const updateBTATenderData = {
            'paymentOption': constants.btaPaymentOption,
            'editTenderType': constants.btaTenderType,
            'preOrderDetails': this.preOrderData,
            'billToAccountMobileNumber': this.btaMobileNumber
        };
        this.UpdatePreorderTender(updateBTATenderData);
    }
    UpdateSavedCCPreorderTender() {
        this.modalError = null;
        this.loaderService.showLoading();
        let paymentOption;
        if (this.selectedSavedCC.ccCount) {
            paymentOption = JSON.stringify(this.selectedSavedCC.ccCount);
        }
        else {
            paymentOption = true;
        }
        const selectedAddressOption = this.selectedAddressOption === 'newAddress';
        const savedCCTenderData = {
            'card': this.prepareCCContent(null, null),
            paymentOption,
            'preOrderDetails': this.preOrderData,
            'editTenderType': constants.ccTenderType,
            'editAddress': selectedAddressOption,
            'differentCreditCardAddressPresent': selectedAddressOption
        };
        this.UpdatePreorderTender(savedCCTenderData);
    }
    UpdateNewCCPreorderTender() {
        this.modalError = null;
        this.loaderService.showLoading();
        this.getOauthAccessToken(this.newCCDetails);
    }
    getOauthAccessToken(ccDetails) {
        this.orderService.getOauthAccessToken().subscribe((data) => {
            var _a, _b;
            const bearerToken = 'Bearer ' + data.accessToken;
            if ((ccDetails === null || ccDetails === void 0 ? void 0 : ccDetails.fullName) && ((_a = ccDetails === null || ccDetails === void 0 ? void 0 : ccDetails.fullName) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const tempArr = ccDetails.fullName.split(' ');
                if (tempArr.length >= 2) {
                    this.selectedCCAddress.firstName = tempArr[0];
                    this.selectedCCAddress.lastName = tempArr[1];
                }
                else {
                    this.selectedCCAddress.firstName = ccDetails.fullName;
                }
            }
            const paymentDetails = {
                'expirationMonth': ccDetails.cardExpirationMonth,
                'expirationYear': ccDetails.cardExpirationYear,
                'creditCardNumber': ccDetails.cardNumber,
                'cvv': ccDetails.cvv
            };
            const creditCardData = this.orderService.getCreditCardRequest(paymentDetails, this.selectedCCAddress, (_b = this.preOrderData) === null || _b === void 0 ? void 0 : _b.pendingTotal);
            this.getCreditCardToken(ccDetails, creditCardData, bearerToken, data.paymentTokenUrl);
        }, (err) => {
            this.modalError = err;
            this.loaderService.hideLoading();
            return null;
        });
    }
    getCreditCardToken(newCCDetails, creditCardData, bearerToken, paymentUrl) {
        this.newCCType = this.getCardType(newCCDetails.cardNumber);
        this.orderService.getPaymentToken(creditCardData, bearerToken, paymentUrl).subscribe((resp) => {
            let newCreditCardData = this.prepareCCContent(newCCDetails, resp.token);
            newCreditCardData = _.omit(newCreditCardData, [
                'creditCardTypeDisplay',
                'ccCount',
                'defaultCard',
                'kHash',
                'address2',
                'creditCardDetailId',
                'cardExpiring',
                'editAddress'
            ]);
            newCreditCardData['kHashToken'] = resp.khash;
            const selectedAddressOption = this.selectedAddressOption === 'newAddress';
            const newCCTenderData = {
                'card': newCreditCardData,
                'paymentOption': true,
                'preOrderDetails': this.preOrderData,
                'editTenderType': constants.ccTenderType,
                'editAddress': selectedAddressOption,
                'differentCreditCardAddressPresent': selectedAddressOption
            };
            this.UpdatePreorderTender(newCCTenderData);
        }, (err) => {
            this.isBTAEligible = false;
            this.getTokenServiceErrorMessage(err);
            this.loaderService.hideLoading();
        });
    }
    getCardType(content) {
        const cardRegExp = {
            Visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
            Master: /^5[1-5][0-9]{14}$/,
            Amex: /^3[47][0-9]{13}$/,
            Discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
        };
        for (const key in cardRegExp) {
            if (cardRegExp[key].test(content)) {
                return key;
            }
        }
    }
    getTokenServiceErrorMessage(error) {
        const errorJson = this.tokenErrorMessage;
        let errorMessage;
        if (error.status === 0 || error.statusText === 'error' || error.status === 500) {
            errorMessage = errorJson['401'];
        }
        else {
            if (error.code) {
                errorMessage = errorJson[error.code];
            }
            else {
                errorMessage = errorJson['000'];
            }
        }
        if (errorMessage) {
            const errorMap = {
                'code': error.code,
                'message': errorMessage
            };
            this.modalError = errorMap;
        }
        else {
            this.modalError = error;
        }
    }
    UpdatePreorderTender(content) {
        this.orderService.updatePreorderTender(content).subscribe((res) => {
            this.resetPaymentSection();
            this.modalRef.close();
            this.loaderService.hideLoading();
            this.openSuccessModal();
        }, (error) => {
            this.modalError = error;
            this.isBTAEligible = false;
            this.loaderService.hideLoading();
        });
    }
    setSelectedAddressOption(event) {
        this.selectedAddressOption = event;
        this.disableSubmitButton = this.selectedAddressOption === 'newAddress';
    }
    setSelectedAddress(event) {
        this.selectedCCAddress = event;
        this.disableSubmitButton = false;
    }
    prepareCCContent(ccDetails, token) {
        const card = {
            'creditCardDetailId': this.isPayingThroughSavedCard && this.selectedSavedCC ? this.selectedSavedCC.creditCardDetailId : null,
            'cvv': this.isPayingThroughSavedCard ? null : ccDetails.cvv,
            'editAddress': this.selectedAddressOption === 'newAddress',
            'creditCardNumber': this.isPayingThroughSavedCard && this.selectedSavedCC ? this.selectedSavedCC.creditCardNumber : token,
            'creditCardType': this.isPayingThroughSavedCard && this.selectedSavedCC ? this.selectedSavedCC.creditCardType : this.newCCType,
            'cardExpMonth': this.isPayingThroughSavedCard && this.selectedSavedCC ? this.selectedSavedCC.cardExpMonth : ccDetails.cardExpirationMonth,
            'cardExpYear': this.isPayingThroughSavedCard && this.selectedSavedCC ? this.selectedSavedCC.cardExpYear : ccDetails.cardExpirationYear,
            'firstName': this.selectedCCAddress.firstName,
            'lastName': this.selectedCCAddress.lastName,
            'kHash': this.isPayingThroughSavedCard && this.selectedSavedCC ? this.selectedSavedCC.kHash : null,
            'defaultCard': false,
            'cardExpiring': false,
            'ccCount': this.isPayingThroughSavedCard && this.selectedSavedCC ? this.selectedSavedCC.ccCount : null,
            'creditCardTypeDisplay': this.isPayingThroughSavedCard && this.selectedSavedCC ? this.selectedSavedCC.creditCardType : this.newCCType,
            'address1': this.selectedCCAddress.address1,
            'city': this.selectedCCAddress.city,
            'state': this.selectedCCAddress.state,
            'zipCode': this.selectedCCAddress.postalCode,
            'cardDataCaptureMethod': constants.ccCaptureMethod
        };
        return card;
    }
    getLoaderStatus() {
        this.modalLoader = this.loaderService.isLoading();
    }
    openSuccessModal() {
        this.modalRef = this.modalService.open(this.modalEditPaymentSuccess, { centered: true });
        this.modalRef.result.then(() => {
        }, () => {
            this.refreshPreorderDetails();
        });
    }
    refreshPreorderDetails() {
        this.refreshPreorderDetailsEmitter.emit(true);
    }
    getUICardType(cardType) {
        return this.orderService.getDisplayCardType(cardType);
    }
    ngOnDestroy() {
        this.loadingSubscription.unsubscribe();
        this.resetPaymentSection();
        this.modalRef = this.modalService.dismissAll();
    }
}
exports.CSMMAPreOrderPaymentMethodsComponent = CSMMAPreOrderPaymentMethodsComponent;
//# sourceMappingURL=payment-methods.component.js.map